import React, { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../hooks/redux';
import { FormInputText } from '../../inputs/FormInputText';
import { CustomMUIButton } from '../../commons/buttons/CustomMUIButton';
import { ButtonClassNames, InputTextFormat, LocalStorageItems, InputRegexPattern } from '../../../models/Common';
import { FormInputCheckbox } from '../../inputs/FormInputCheckbox';
import { ReactComponent as CheckBoxIcon } from '../../../assets/images/EmptyCheckBox.svg';

interface CallMeProps {
  handleCallMeBack: (callMe: { phone: string; userComment: string; viber: boolean }) => void;
  isLoading: boolean;
}

export const CallMeBack: FC<CallMeProps> = ({ handleCallMeBack, isLoading }) => {
  const { t } = useTranslation();
  const { userInfoState } = useAppSelector((state) => state.userInfoReducer);
  const { isAuth } = useAppSelector((state) => state.authReducer);
  const cachedData = localStorage.getItem(`${LocalStorageItems.CallMeBack}-${userInfoState.id}`);
  const showDefaults = isAuth && cachedData && JSON.parse(cachedData)[userInfoState.id];
  const defaultPhone =
    showDefaults && JSON.parse(cachedData)[userInfoState.id].phone
      ? JSON.parse(cachedData)[userInfoState.id].phone
      : '';
  const methods = useForm({
    defaultValues: {
      phone: userInfoState.SmsSettings?.Phone || defaultPhone,
      userComment: '',
      viber: false,
    },
  });
  const { handleSubmit } = methods;

  return (
    <div className="call-me-back-form">
      <p className="call-me-back-form__title">{t('callMeBack.callMeBack')}</p>
      <FormProvider {...methods}>
        <form className="call-me-back-form" onSubmit={handleSubmit(handleCallMeBack)}>
          <FormInputText
            name="phone"
            label={t('callMeBack.phone')}
            className="primary"
            isRequired
            format={InputTextFormat.Phone}
            pattern={InputRegexPattern.Phone}
          />
          <FormInputText name="userComment" className="primary" label={t('input.comment')} maxLength={100} />
          <div>
            <p className="additional__connection__title">{t('callMeBack.additionalConnection')}</p>
            <div className="checkBox__container">
              <FormInputCheckbox
                name="viber"
                icon={<CheckBoxIcon />}
                label={<div className="modals__form__label viber">{t('callMeBack.connectionViber')} </div>}
              />
            </div>
          </div>
          <CustomMUIButton
            label={t('common.sendRequest')}
            className={ButtonClassNames.PrimaryFulfilled}
            isBold
            type="submit"
            isLoading={isLoading}
          />
        </form>
      </FormProvider>
    </div>
  );
};
